import {
  HeadContent,
  Outlet,
  createRootRouteWithContext,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import posthog from "posthog-js";
import { CookiesProvider, useCookies } from "react-cookie";
import { ErrorScreen } from "~/components/error-screen";
import { SidebarProvider } from "~/components/ui/sidebar";
import { Toaster } from "~/components/ui/sonner";
import type { RouterContext } from "~/main";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <CookiesProvider>
      <AppRoute />
    </CookiesProvider>
  ),
  beforeLoad: async ({ search }) => {
    const searchParams = new URLSearchParams(window.location.search);
    const playgroundUser = searchParams.get("playground_user");
    if (playgroundUser) {
      posthog.alias(playgroundUser);
    }
  },
  errorComponent: ({ error }) => <ErrorScreen error={error} />,
});

function AppRoute() {
  const [cookies] = useCookies();
  const defaultOpen = cookies.sidebar_state !== false;

  return (
    <SidebarProvider defaultOpen={defaultOpen}>
      <Outlet />
      <HeadContent />
      <TanStackRouterDevtools position="bottom-right" />
      <Toaster />
    </SidebarProvider>
  );
}
